import { inquiryApi, SupplierInquiry } from '@texas/api/endpoints/inquiryApi';
import { useApiRequest } from '@texas/api/hooks/useApiRequest';
import { AddMultipleTiersModal } from '@texas/components/shared/tiers/AddMultipleTiersModal';
import { inquiryEvents } from './events';
import { useTranslation } from 'react-i18next';

interface Props {
  inquiry: SupplierInquiry;
  isOpen: boolean;
  onClose: () => void;
}

export function AddMultipleInquiryTiersModal({
  inquiry,
  isOpen,
  onClose,
}: Props) {
  const { t } = useTranslation();
  const {
    request: addTierRequest,
    loading: adding,
    error: addingError,
  } = useApiRequest(inquiryApi.addTierPrice);

  return (
    <AddMultipleTiersModal
      title={t('tiers.addMultiple')}
      existingQuantities={inquiry.tierPrices.map((tier) => tier.quantity)}
      recommendedQuantities={inquiry.allTargetTiers.map(
        (tier) => tier.quantity,
      )}
      submitting={adding}
      submitError={addingError}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={async (quantities) => {
        for (const quantity of quantities) {
          const response = await addTierRequest(inquiry.id, quantity, null);
          if (response.hasError) {
            return false;
          }
        }

        inquiryEvents.onUpdated.dispatch();
        return true;
      }}
    />
  );
}
